const { displayMessage } = require("../../services/helper");

module.exports = {
    OPEN_LIP: {
      description: displayMessage('OPEN_LIP'), code: 1, field: "open_lip"
    },
    CAMERA_OFF: {
      description: displayMessage('CAMERA_MICROPHONE'), code: 3, field: "camera_off"
    },
    CHEWING: {
      description: displayMessage('CHEWING_TALCKING'), code: 4, field: "chewing"
    },
    CAMERA_POSITION: {
      description: displayMessage('CAMERA'), code: 7, field: "camera_position"
    },
    CORRECT_EXECUTION: {
      description: displayMessage('EXECUTION'), code: 8, field: "correct_execution"
    },
    CONCENTRATION_ACTIVITY: {
      description: displayMessage('ATENTION'), code: 10, field: "concentration_activity"
    },
    EXERCISE_DONE: {
      description: displayMessage('EXERCISE_DONE'), code: 12, field: "exercise_done"
    },
    PATIENT_PAUSE: {
      description: displayMessage('MONITORY_PAUSE'), code: 13, field: ""
    },
    PATIENT_RESUME: {
      description: displayMessage('MONITORY_RESUME'), code: 14, field: ""
    },
    PATIENT_PAUSE_EXERCISE: {
      description: displayMessage('EXERCISE_PAUSE'), code: 15, field: ""
    },
    EXERCISE_START: {
      description: displayMessage('EXERCISE_START'), code: 16, field: ""
    },
    RESUME_CONTROL: {
      description: displayMessage('RESUME_FINISHED_MONITORY'), code: 17, field: "recovering_interval"
    },
    END_CONTROL: {
      description: displayMessage('FINISHED_MONITORY'), code: 18, field: ""
    },
    MONITOR_EXCHANGE: {
      description: displayMessage('MONITOR_EXCHANGE'), code: 19, field: ""
    },
    PATIENT_ABSENCE: {
      description: displayMessage('PATIENT_ABSENCE'), code: 20, field: ""
    },
    START_MONITORY: {
      description: displayMessage('START_MONITORY'), code: 21, field: ""
    },
    CANCEL_WAITING: {
      description: displayMessage('CANCEL_WAITING'), code: 22, field: ""
    },
    CREATED_IN_EXERCISE: {
      description: displayMessage('CREATED_IN_EXERCISE'), code: 23, field: ""
    },
  
    //Eventos excluidos do sistema, devem permanecer aqui para que o historic do sistema funcione adequadamente
    DELAY_ADJUST: {
      description: displayMessage('DELAY_ADJUST'), code: 2, field: "delay_adjust"
    },
    MIC_OFF: {
      description: displayMessage('MIC_OFF'), code: 5, field: "mic_off"
    },
    TALKING: {
      description: displayMessage('TALKING'), code: 6, field: "talking"
    },
  }
  